import type { HelpFile } from '../../types/help'
import { DefinitionImpactConfirmDialogTestIds } from '../../../testids/DefinitionImpactConfirmDialogTestIds'

export const definitionImpactConfirmDialogHelp: HelpFile = {
  docPage: '/docs/admin/attribute-definitions',
  texts: {
    [DefinitionImpactConfirmDialogTestIds.definitionImpactConfirmDialog]:
      'Diese Änderung an der Attributdefinition wirkt sich auf vorhandene Daten aus — Auswirkungen prüfen und entscheiden, ob Werte migriert werden sollen.',
    [DefinitionImpactConfirmDialogTestIds.impactConfirmationCheckbox]:
      'Bestätigen, dass die Auswirkungen geprüft wurden, bevor gespeichert wird.',
    [DefinitionImpactConfirmDialogTestIds.impactConfirmButton]: 'Änderungen speichern, ohne vorhandene Werte zu migrieren.',
    [DefinitionImpactConfirmDialogTestIds.saveWithMigrationButton]: 'Speichern und vorhandene Attributwerte, soweit sicher möglich, auf die neue Definition migrieren.',
    [DefinitionImpactConfirmDialogTestIds.impactConfirmCancel]: null,
  },
}
